module.exports = __webpack_public_path__ + "media/images/iconRight__accent-dee368394f56f612758762a6f3bb3223.png";